<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">溯源管理</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item label="仓库：">
          <el-select v-model="query.sellerId" clearable>
            <el-option v-for="(item, index) in sellers" :key="index" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>溯源列表</span>
    </div>
    <div class="content-data">
      <el-table highlight-current-row :data="data" border :span-method="objectSpanMethod">
        <el-table-column align="center" label="序号" type="index" width="50px"/>
        <el-table-column align="center" label="仓库名称" width="150px" prop="sellerName"/>
        <el-table-column align="center" label="联系人" prop="linkman"/>
        <el-table-column label="产品溯源基本信息" align="center">
          <el-table-column align="center" label="溯源编号" prop="code"/>
          <el-table-column align="center" label="产品信息溯源" prop="productName"/>
          <el-table-column align="center" label="产品图片">
            <template slot-scope="scope">
              <img :src="dynamicResourcePath+scope.row.iconPath" width="75px" height="75px"/>
            </template>
          </el-table-column>
          <el-table-column align="center" label="产品产地" prop="placeOrigin"/>
          <el-table-column align="center" label="保质期" prop="shelfLife"/>
          <el-table-column align="center" label="存储条件" prop="storageConditions"/>
          <el-table-column align="center" label="生产日期" prop="productionDate"/>
        </el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="270px">
          <template slot-scope="scope">
            <p>
              <el-button type="primary" size="mini"
                         @click="$router.push({name:'goodsTraceabilityDetail',query:{id:scope.row.id}} )">
                修改
              </el-button>
              <el-button type="primary" size="mini"
                         @click="visible=true;selectId=scope.row.id;">
                生产过程
              </el-button>
            </p>
            <p>
              <el-button size="mini" @click="downloadQrcode(scope.row.qrcodePath,scope.row.code)">
                打印基地溯源码
              </el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <traceability-upload :success="success" ref="traceability-upload"></traceability-upload>
    <traceability-item :visible.sync="visible" :id.sync="selectId" title="生产过程"/>
    <vue-pager :datafile="fillData" url="/traceability/pageTraceability" :query="query" ref="pager"
               :init="true"></vue-pager>
  </div>
</template>
<script>
import traceabilityUpload from '@/components/traceabilityUpload.vue';
import TraceabilityItem from './detail/traceability-item';


export default {
  data() {
    return {
      visible: false,
      selectId: '',
      type: '',
      query: {},
      data: [],
      sellers: [],
      dynamicResourcePath: config.dynamicResourcePath
    }
  },
  components: {
    traceabilityUpload,
    TraceabilityItem
  },
  created() {
    this.findSeller()
  },
  methods: {
    fillData(_response) {
      this.data = _response.items || [];
    },
    submitQuery(_num) {
      this.$refs.pager.gotoPage(_num);
    },
    success() {
      if (this.$refs.pager) {
        this.submitQuery(1);
      }
    },
    findSeller() {
      var _this = this;
      _this.$common.my_ajax({
        url: 'seller/pageSeller',
        data: {
          limit: -1
        },
        success: function (response) {
          _this.sellers = response.items;
        }
      });
    },
    downloadQrcode(_path, _code) {
      let a = document.createElement('a');
      a.setAttribute("href", config.dynamicResourcePath + _path);
      a.setAttribute("download", _code);
      a.click();
    },
  },
}
</script>